import styled from 'styled-components';
import { screenSm } from 'constants/styles/breakpoints';

export const Container = styled.div<{ mobileOnly?: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  max-width: 100%;
  grid-gap: 10px;
  background-color: #f2f2f7;
  padding: 15px 0;
  align-items: stretch;
  box-sizing: border-box;
  overflow: hidden;

  ${screenSm} {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    align-items: stretch;
  }
  & > div {
    min-width: 0;
    :nth-child(1) {
      grid-column: span 1;
    }
    :nth-child(2) {
      order: initial;
    }
  }
`;

export const VoucherCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #e9e9ed;
  border-radius: 10px;
  padding: 20px 10px;
  flex-grow: 1;
  position: relative;
  transition: box-shadow 0.6s ease;
  grid-column: span 1;

  ${screenSm} {
    flex: 0 0 471px;
    width: 471px;
    min-height: 98px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border: 0;
    padding: 20px;
  }

  &:hover {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  }
`;

export const NoVoucherCard = styled(VoucherCard)`
  border-left: 10px solid #e52a2a;
`;

export const VoucherQuantity = styled.span`
  font-weight: 700;
  font-size: 42px;
  color: #1a2535;
  text-align: center;
  line-height: 38px;
`;

export const VoucherInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const VoucherDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 152px;
`;

export const VoucherLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1a2535;
  white-space: nowrap;
`;

export const VoucherActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: auto;
  min-height: auto;

  ${screenSm} {
    align-items: flex-end;
    width: 189px;
    min-height: 58px;
  }
`;

export const NoVoucherActions = styled(VoucherActions)`
  justify-content: center;
`;

export const NeedMoreVouchers = styled.span`
  font-size: 12px;
  line-height: 14px;
  color: #1a2535;
  text-align: center;

  ${screenSm} {
    white-space: nowrap;
  }
`;

export const ContactSalesButton = styled.button`
  cursor: pointer;
  border: 0;
  padding: 0;
  background: transparent;
  font: inherit;
  line-height: inherit;
  margin-left: 5px;
  color: var(--lilac-dark, #7965c6);

  &:focus-visible {
    outline: 2px solid var(--lilac-dark, #7965c6);
    outline-offset: 2px;
  }

  &:hover,
  &:active {
    color: var(--lilac-dark, #7965c6);
    text-decoration: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 15px;
`;

export const ModalContent = styled.div`
  padding: 30px;
  text-align: center;
`;

export const ModalTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1a2535;
  margin-bottom: 16px;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  color: #57575c;
  margin-bottom: 24px;
  line-height: 1.5;
`;

export const ModalIcon = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f5;
  border-radius: 50%;
`;

export const ModalButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

// Assign Voucher Modal Styles
export const AssignModalContent = styled.div`
  padding: 24px;
`;

export const AssignModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #1a2535;
  margin-bottom: 24px;
`;

export const ExamSelectorWrapper = styled.div`
  margin-bottom: 24px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #1a2535;
    margin-bottom: 8px;
  }
`;

export const MembersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const MembersCount = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1a2535;
`;

export const SearchWrapper = styled.div`
  margin-bottom: 16px;

  .ant-input-search {
    .ant-input {
      border-radius: 6px;
    }
  }
`;

export const MembersListWrapper = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e9e9ed;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 24px;
  background-color: #fafafa;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;

    &:hover {
      background: #999;
    }
  }
`;

export const MemberItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background-color: #fff;
  border: 1px solid #e9e9ed;
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: #d0d0d5;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
`;

export const MemberCheckbox = styled.div`
  padding-top: 2px;
  margin-right: 12px;
`;

export const MemberInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MemberName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1a2535;
  display: flex;
  align-items: center;
`;

export const MemberEmail = styled.div`
  font-size: 13px;
  color: #57575c;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;

  p {
    margin: 0;
    color: #57575c;
    font-size: 14px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 12px;

  p {
    margin: 0;
    color: #999;
    font-size: 14px;
    text-align: center;
  }
`;

export const ErrorMessage = styled.div`
  padding: 16px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  color: #ff4d4f;
  font-size: 14px;
  text-align: center;
`;

export const AssignModalButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
`;
